import React, { createContext, useContext, useEffect, useState } from "react";
import { it } from "./it";
import { ar } from "./ar";

const I18nContext = createContext(null);

const DICT = { it, ar };

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("fiscoai_lang") || "it");

    useEffect(() => {
        localStorage.setItem("fiscoai_lang", lang);
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    }, [lang]);

    const t = DICT[lang] || it;
    const toggleLang = () => setLang((l) => (l === "it" ? "ar" : "it"));

    return (
        <I18nContext.Provider value={{ lang, setLang, toggleLang, t, dir: lang === "ar" ? "rtl" : "ltr" }}>
            {children}
        </I18nContext.Provider>
    );
}

export function useI18n() {
    return useContext(I18nContext);
}
